/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EvmItemActivityListInfo } from '../models/EvmItemActivityListInfo';
import type { EvmTokenHolderListInfo } from '../models/EvmTokenHolderListInfo';
import type { EvmTokenInventoryCountInfo } from '../models/EvmTokenInventoryCountInfo';
import type { EvmTokenInventoryListInfo } from '../models/EvmTokenInventoryListInfo';
import type { EvmTokenItemHolderListInfo } from '../models/EvmTokenItemHolderListInfo';
import type { EvmTokenItemProfileInfo } from '../models/EvmTokenItemProfileInfo';
import type { EvmTokenOwnerHistoryListInfo } from '../models/EvmTokenOwnerHistoryListInfo';
import type { EvmTokenTransferListInfo } from '../models/EvmTokenTransferListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class EvmErc1155ControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns EvmTokenTransferListInfo OK
     * @throws ApiError
     */
    public getEvmErc1155TransferList({
        ca,
        page = 1,
        size = 25,
    }: {
        ca?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenTransferListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC1155/transfer/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenTransferListInfo OK
     * @throws ApiError
     */
    public getEvmErc1155TransferList1({
        ca,
        page = 1,
        size = 25,
    }: {
        ca?: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenTransferListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC1155/transfer/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenItemProfileInfo OK
     * @throws ApiError
     */
    public getEvmErc1155Profile({
        ca,
        tokenId,
    }: {
        ca: string,
        tokenId: string,
    }): CancelablePromise<EvmTokenItemProfileInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC1155/item/profile',
            query: {
                'ca': ca,
                'tokenId': tokenId,
            },
        });
    }

    /**
     * @returns EvmTokenItemProfileInfo OK
     * @throws ApiError
     */
    public getEvmErc1155Profile1({
        ca,
        tokenId,
    }: {
        ca: string,
        tokenId: string,
    }): CancelablePromise<EvmTokenItemProfileInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC1155/item/profile',
            query: {
                'ca': ca,
                'tokenId': tokenId,
            },
        });
    }

    /**
     * @returns EvmTokenItemHolderListInfo OK
     * @throws ApiError
     */
    public getEvmErc1155ItemHolderInfoList({
        ca,
        tokenId,
        page = 1,
        size = 10,
    }: {
        ca: string,
        tokenId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenItemHolderListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC1155/item/holder/list',
            query: {
                'ca': ca,
                'tokenId': tokenId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenItemHolderListInfo OK
     * @throws ApiError
     */
    public getEvmErc1155ItemHolderInfoList1({
        ca,
        tokenId,
        page = 1,
        size = 10,
    }: {
        ca: string,
        tokenId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenItemHolderListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC1155/item/holder/list',
            query: {
                'ca': ca,
                'tokenId': tokenId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenOwnerHistoryListInfo OK
     * @throws ApiError
     */
    public getEvmErc1155OwnerHistoryInfoList({
        ca,
        tokenId,
        page = 1,
        size = 10,
    }: {
        ca: string,
        tokenId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenOwnerHistoryListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC1155/item/holder/history/list',
            query: {
                'ca': ca,
                'tokenId': tokenId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenOwnerHistoryListInfo OK
     * @throws ApiError
     */
    public getEvmErc1155OwnerHistoryInfoList1({
        ca,
        tokenId,
        page = 1,
        size = 10,
    }: {
        ca: string,
        tokenId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenOwnerHistoryListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC1155/item/holder/history/list',
            query: {
                'ca': ca,
                'tokenId': tokenId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmItemActivityListInfo OK
     * @throws ApiError
     */
    public getEvmErc1155ItemActivityInfoList({
        ca,
        tokenId,
        page = 1,
        size = 25,
    }: {
        ca: string,
        tokenId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmItemActivityListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC1155/item/activity/list',
            query: {
                'ca': ca,
                'tokenId': tokenId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmItemActivityListInfo OK
     * @throws ApiError
     */
    public getEvmErc1155ItemActivityInfoList1({
        ca,
        tokenId,
        page = 1,
        size = 25,
    }: {
        ca: string,
        tokenId: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmItemActivityListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC1155/item/activity/list',
            query: {
                'ca': ca,
                'tokenId': tokenId,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenInventoryCountInfo OK
     * @throws ApiError
     */
    public getEvmErc1155InventoryListCount({
        ca,
    }: {
        ca: string,
    }): CancelablePromise<EvmTokenInventoryCountInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC1155/inventory/list/count',
            query: {
                'ca': ca,
            },
        });
    }

    /**
     * @returns EvmTokenInventoryCountInfo OK
     * @throws ApiError
     */
    public getEvmErc1155InventoryListCount1({
        ca,
    }: {
        ca: string,
    }): CancelablePromise<EvmTokenInventoryCountInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC1155/inventory/list/count',
            query: {
                'ca': ca,
            },
        });
    }

    /**
     * @returns EvmTokenInventoryListInfo OK
     * @throws ApiError
     */
    public getEvmErc1155InventoryList({
        ca,
        page = 1,
        size = 25,
    }: {
        ca: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenInventoryListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC1155/inventory/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenInventoryListInfo OK
     * @throws ApiError
     */
    public getEvmErc1155InventoryList1({
        ca,
        page = 1,
        size = 25,
    }: {
        ca: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenInventoryListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC1155/inventory/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenHolderListInfo OK
     * @throws ApiError
     */
    public getEvmErc1155HolderList({
        ca,
        page = 1,
        size = 25,
    }: {
        ca: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenHolderListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/evm/token/ERC1155/holder/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

    /**
     * @returns EvmTokenHolderListInfo OK
     * @throws ApiError
     */
    public getEvmErc1155HolderList1({
        ca,
        page = 1,
        size = 25,
    }: {
        ca: string,
        page?: number,
        size?: number,
    }): CancelablePromise<EvmTokenHolderListInfo> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/token/ERC1155/holder/list',
            query: {
                'ca': ca,
                'page': page,
                'size': size,
            },
        });
    }

}
